import '../types/externs'
import websocket from './'

module.exports = {
  '_websocket': websocket,
}